import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import dayjs from "dayjs";
import Layout from "../../components/layout/Layout";
import {
  Grid,
  Box,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Admin from "../../components/auth/Admin";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableHead,
  TextField,
} from "@mui/material";
import Notification from "../../components/customHelpers/Notification";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { useHistory, useLocation } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import {
  cleanActivityString,
  getActivityRedirectPath,
  getTimestamp,
  pageSizes,
} from "../../utils/utils";
import Organization from "../../actions/organization";
import Controls from "../../components/controls/Controls";
import FilterExportButtons from "./filterExportButton";
const initialHeadCells = [
  { id: "activity", label: "Activity", isVisible: true },
  { id: "staff", label: "Staff", isVisible: true },
  { id: "createdAt", label: "Date", isVisible: true },
  { id: "action", label: "Action", isVisible: true },
];

const ActivityLog = () => {
  const history = useHistory();
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllActivity, viewAllStaffs } = Organization();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [activitys, setActivitys] = useState([]);
  const [tempActivity, setTempActivity] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllActivity();
  }, [page, limit, searchQuery, startDate, endDate, selectedStaff]);
  useEffect(() => {
    getAllStaffs();
  }, []);
  const getAllActivity = () => {
    setValues({ ...values, loading: true });
    viewAllActivity(
      page,
      limit,
      searchQuery,
      startDate,
      endDate,
      selectedStaff?.fullName
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.activity) {
        setValues({
          ...values,
          loading: false,
        });
        setActivitys(data.activity);
        setTempActivity(data.activity);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };

  const getAllStaffs = () => {
    setValues({ ...values, loading: true });
    viewAllStaffs().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.staffs) {
        setValues({
          ...values,
          loading: false,
        });
        setStaffs(data.staffs);
      }
    });
  };
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(activitys, initialHeadCells, filterFn);

  const handleStartDateChange = (newValue) => {
    setPage(1);
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue) => {
    setPage(1);
    setEndDate(newValue);
  };
  const generateReportFilename = (startDate, endDate, staffName, timestamp) => {
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "AllDates";
    const formattedEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
    const formattedStaffName = staffName ? staffName : "AllStaff";

    return `${formattedStartDate}_${formattedEndDate}_${formattedStaffName}_Activity-log-report_${timestamp}`;
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = activitys.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "activity":
            return item.activity;
          case "staff":
            return item.staff?.fullName;
          case "organization":
            return item.organization?.organization_name;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedStaff?.fullName,
      timestamp
    );
    saveAs(blob, `${filename}.xlsx`);
    handleClose();
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);

    // Prepare the data for the table
    const bodyData = activitys.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "activity":
            return item.activity;
          case "staff":
            return item.staff?.fullName;
          case "organization":
            return item.organization?.organization_name;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );
    doc.autoTable({
      head: [filteredHeadCells.map((cell) => cell.label)],
      body: bodyData,
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });

    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedStaff?.fullName,
      timestamp
    );
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const clearFilters = () => {
    setPage(1);
    setStartDate(null);
    setEndDate(null);
    setInputValue("");
    setSelectedStaff(null);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [inputValue, setInputValue] = useState("");
  const filteredOptions = staffs?.filter((option) =>
    option.fullName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleSearchChange = (event, value) => {
    if (value) {
      setSelectedStaff(value);
      setPage(1);
    }
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  const ismedium = useMediaQuery("(min-width:650px) and (max-width:1100px)");

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Activity Log Report
          </Typography>

          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            gap={2}
            m={1}
          >
            <Box sx={{ width: { xs: "100%", sm: ismedium ? "30%" : "20%" } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    slotProps={{
                      textField: {
                        InputLabelProps: { shrink: true },
                      },
                      field: {
                        clearable: true,
                        onClear: () => setActivitys(tempActivity),
                      },
                    }}
                    onChange={handleStartDateChange}
                    sx={{ "& .MuiInputBase-root": { height: 45 } }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box sx={{ width: { xs: "100%", sm: ismedium ? "30%" : "20%" } }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="End Date"
                    slotProps={{
                      textField: {
                        InputLabelProps: { shrink: true },
                      },
                      field: {
                        clearable: true,
                        onClear: () => setActivitys(tempActivity),
                      },
                    }}
                    value={endDate}
                    sx={{
                      "& .MuiInputBase-root": { height: 45 },
                      width: { xs: "100%", sm: "20%" },
                    }}
                    onChange={handleEndDateChange}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Autocomplete
              sx={{
                marginTop: "8px",
                width: { xs: "100%", sm: ismedium ? "30%" : "20%" },
              }}
              options={searchTerm ? filteredOptions : []}
              getOptionLabel={(option) => option.fullName}
              onChange={handleSearchChange}
              onInputChange={(event, newInputValue) =>
                setInputValue(newInputValue)
              }
              value={selectedStaff}
              inputValue={inputValue}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Staff Name"
                  variant="outlined"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              )}
            />
            {!ismedium && (
              <FilterExportButtons
                clearFilters={clearFilters}
                exportToPDF={exportToPDF}
                exportToExcel={exportToExcel}
              />
            )}
          </Box>
          {ismedium && (
            <FilterExportButtons
              clearFilters={clearFilters}
              exportToPDF={exportToPDF}
              exportToExcel={exportToExcel}
            />
          )}
          <Grid container spacing={2}>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterSortingAndFiltering().length > 0 ? (
                        recordsAfterSortingAndFiltering().map((item) => {
                          const redirectPath = getActivityRedirectPath(item);
                          return (
                            <TableRow key={item.id}>
                              <TableCell style={{ width: "15%" }}>
                                {cleanActivityString(item.activity)}
                              </TableCell>{" "}
                              <TableCell style={{ width: "15%" }}>
                                {item?.staff?.fullName}
                              </TableCell>
                              <TableCell>
                                {new Date(item.createdAt).toLocaleString()}
                              </TableCell>
                              <TableCell>
                                {redirectPath && (
                                  <Controls.ActionButton
                                    color="primary"
                                    title="View Detail"
                                    onClick={() => {
                                      history.push(redirectPath);
                                    }}
                                  >
                                    <FiEye fontSize="medium" />
                                  </Controls.ActionButton>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      p: 2,
                      backgroundColor: "background.paper",
                      borderTop: 1,
                      borderColor: "divider",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {activitys.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || activitys.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={activitys.length === 0}
                      />
                    )}
                  </Box>{" "}
                </Paper>
              )}
            </Grid>
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default ActivityLog;
